import Action from '../../actions/events'
import { IEvent } from '../../models/Event'
import { IDateRange } from '../../utils/Date'
import { EventActions, RoomActions } from '../bookingCalendar/actionNames'
import eventWasCreated from '../bookingCalendar/mutators/eventWasCreated'
import eventWasUpdated from '../bookingCalendar/mutators/eventWasUpdated'
import addEventsBulk from '../bookingCalendar/mutators/addEventsBulk'
import eventWasTransfered from '../bookingCalendar/mutators/eventWasTransfered'
import { SynchronizeActions } from '../synchronize/actionNames'
import flushEvents from '../bookingCalendar/mutators/flushEvents'
import eventWasDeleted from '../bookingCalendar/mutators/eventWasDeleted'
import requestDataEvents from '../bookingCalendar/mutators/requestDataEvents'
import requestEventsAccepted from '../bookingCalendar/mutators/requestEventsAccepted'
import requestEventsRejected from '../bookingCalendar/mutators/requestEventsRejected'
import { AuthorizationActions } from '../userAccount/actionNames'
import requestEventPdfSuccess from './mutators/requestEventPdfSuccess'
import requestEventPdfFailure from './mutators/requestEventPdfFailure'
import requestEventPdf from './mutators/requestEventPdf'
import clearPdf from './mutators/clearPdf'
import initialStore from './initialState'
import { EventPdfActions } from './actionNames'

export default function(
  store: Readonly<IEventsStore> = initialStore,
  action: Action | any,
) {
  switch (action.type) {
    case AuthorizationActions.FlushState:
      return initialStore
    case EventPdfActions.EventPdfRequest:
      return requestEventPdf(store, action)
    case EventPdfActions.EventPdfRequestSuccess:
      return requestEventPdfSuccess(store, action)
    case EventPdfActions.EventPdfRequestFailure:
      return requestEventPdfFailure(store, action)
    case EventPdfActions.ClearPdf:
      return clearPdf(store)

    case EventActions.EventWasCreated:
      return eventWasCreated(store, action)
    case EventActions.EventWasUpdated:
      return eventWasUpdated(store, action)
    case EventActions.EventsBulkCreated:
      return addEventsBulk(store, action)
    case EventActions.ReservationWasTransfered:
      return eventWasTransfered(store, action)
    case EventActions.RequestEventsForCalendar:
      return {
        ...store,
        events: [],
        request: {
          ...store.request,
          events: {
            ...store.request.events,
            isLoading: true,
          },
        },
      }
    case EventActions.DataForEventsAccepted:
      return requestEventsAccepted(store, action)
    case EventActions.ToggleFallbackLoading:
      return {
        ...store,
        request: {
          ...store.request,
          events: {
            ...store.request.events,
            isFallbackLoading: action.loading,
            isLoading: false,
          },
        },
      }

    case SynchronizeActions.EventsFlushed:
      return flushEvents(store)
    case EventActions.EventWasDeleted:
      return eventWasDeleted(store, action)
    case EventActions.RequestDataForEvents:
      return requestDataEvents(store)
    case EventActions.DataForEventsRejected:
      return requestEventsRejected(store, action)
    case RoomActions.RoomWasDeleted:
      return {
        ...store,
        events: store.events.filter(event => event.roomId !== action.roomId),
      }
  }

  return store
}

export interface IEventsStore {
  pdf: string
  eventId: string
  events: IEvent[]
  request: {
    events: IRequestState
  }
  loadedDates: IDateRange[]
  fullyLoaded: boolean
  pdfRequest: {
    errMessage: string
    isLoading: boolean
    isSaving: boolean
  }
}

interface IRequestState {
  isLoading: boolean
  isFallbackLoading: boolean
  errMessage: string
  acceptedCount?: number
}
